module.exports = __webpack_public_path__ + "static/media/contentcamel-import-template.585e29f7.csv";